import { Component, OnInit, Input, ViewChild, Output } from '@angular/core';
import { MdbFileUploadComponent } from 'mdb-file-upload';
import { EventEmitter } from '@angular/core';
import { FormFileEntryComponent, IFormFileEntryViewModel } from '../form-file-entry/form-file-entry.component';
import { IDataServiceEntityFileEntry, IDataServiceEntityFileEntryList } from 'src/app/services/data.service.interface';

@Component({
  selector: 'app-file-entry-list',
  templateUrl: './form-file-entry-list.component.html',
  styleUrls: ['./form-file-entry-list.component.scss']
})
export class FormFileEntryListComponent implements OnInit {

  constructor() { }

  @Input() vm: IFormFileEntryListViewModel;

  @ViewChild('uploader', { static: true }) uploader: MdbFileUploadComponent;

  @Output() cancelClicked = new EventEmitter<IFormFileEntryListCancelledArg>();

  fileLoadError: any = '';

  onFileAdd(file: File) {

    const fr = new FileReader();
    fr.readAsDataURL(file);
    fr.onload = () => {
      this.vm.add(file.name, <string>fr.result);
    };
    fr.onerror = error => {
      this.fileLoadError = error;
      console.log(error);
    };
  }

  /**
   *
   * @param vm
   */
  cancelled(vm: IFormFileEntryListViewModel) {
    this.cancelClicked.emit({ vm: vm });
  }

  /**
   * 
   */
  ngOnInit() {
  }

  /**
       *
       * @param title
       * @param data
       * @param changeFunc
       * @param newCodeFunc
       */
  public static viewModel(title: string, data: IDataServiceEntityFileEntryList, changeFunc: () => void, newCodeFunc: () => string): IFormFileEntryListViewModel {

    // helper to set the primary image
    const primaryFunc: (entries: IFormFileEntryViewModel[], code: string) => void =
      (entries, code) => (entries || []).forEach(fe => fe.isPrimary = fe.data.code == code);

    // create the darned thing
    const ret: IFormFileEntryListViewModel = {
      data: data,

      fileEntries: data.fileEntries.map(fe => FormFileEntryComponent.viewModel(fe, () => changeFunc())),

      add: (fileName: string, dataUrl: string) => {
        const fe: IDataServiceEntityFileEntry = {
          fileUrl: dataUrl,
          code: newCodeFunc(),
          name: fileName,
          description: ''
        };
        data.fileEntries.push(fe);

        if (data.fileEntries.length == 1)
          data.primaryImageCode = fe.code;

        const newEntryVm = FormFileEntryComponent.viewModel(fe, () => changeFunc());
        newEntryVm.isPrimary = fe.code == data.primaryImageCode;
        ret.fileEntries.push(newEntryVm);

        changeFunc();
      },
      delete: (code: string) => {
        ret.fileEntries.splice(ret.fileEntries.findIndex(fe => fe.data.code == code), 1);

        data.fileEntries.splice(data.fileEntries.findIndex(fe => fe.code == code), 1);
        if (code == data.primaryImageCode)
          data.primaryImageCode = undefined;

        changeFunc();
      },
      makePrimary: (code: string) => {
        data.primaryImageCode = code;
        primaryFunc(ret.fileEntries, code);
        changeFunc();
      }
    };

    // update props
    primaryFunc(ret.fileEntries, data.primaryImageCode);

    return ret;
  }

}

/**
 *
 */
export interface IFormFileEntryListCancelledArg {
  vm: IFormFileEntryListViewModel;
}

/**
 *
 */
export interface IFormFileEntryListActions {
  add: (fileName: string, dataUrl: string) => void;
  delete: (id: string) => void;
  makePrimary: (id: string) => void;
}

/**
*
*/
export interface IFormFileEntryListViewModel extends IFormFileEntryListActions {
  data: IDataServiceEntityFileEntryList;

  fileEntries: IFormFileEntryViewModel[];
}
